import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getRealEstates } from '../slices/realEstateSlice';
import { getRealEstateTypes } from '../slices/realEstateTypeSlice';
import Loader from '../utilities/Loader';
import NavigationBar from '../NavigationBar';
import WhatsAppButton from '../utilities/WhatsAppButton';
import { useAuth0 } from '@auth0/auth0-react';
import RealEstatesDetail from '../components/realEstate/RealEstatesDetail';
import NotFound from '../utilities/NotFound';
import Footer from '../Footer';

export default function RealEstatesDetailPage() {
  const { isLoading } = useAuth0();
  const { id } = useParams();
  const realEstates = useSelector((state) => state.realEstates.data);
  const realEstatesStatus = useSelector((state) => state.realEstates.status);
  const realEstateTypesStatus = useSelector(
    (state) => state.realEstateTypes.status
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (realEstatesStatus === 'idle' || realEstateTypesStatus === 'idle') {
      dispatch(getRealEstates());
      dispatch(getRealEstateTypes());
    }
  }, [dispatch, realEstatesStatus, realEstateTypesStatus]);

  const selectedRealEstate = realEstates?.find((estate) => estate.id === id);

  return (
    <>
      {realEstatesStatus !== 'succeeded' ||
      realEstateTypesStatus !== 'succeeded' ||
      isLoading ? (
        <Loader />
      ) : (
        <>
          <NavigationBar />
          {selectedRealEstate !== undefined ? (
            <RealEstatesDetail selectedRealEstate={selectedRealEstate} />
          ) : (
            <NotFound isDetail={true} />
          )}
          <WhatsAppButton />
          <Footer />
        </>
      )}
    </>
  );
}
